const DOCUMENT_MENU_SCRAPED_ITEM_DISCREPANCY_IMPACT_LEVEL = {
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
}

export default DOCUMENT_MENU_SCRAPED_ITEM_DISCREPANCY_IMPACT_LEVEL
